// store/modules/admin.js
import axios from 'axios';

export default {
    namespaced: true,
    
    state: {
        stats: {
            totalRevenue: 0,
            totalOrders: 0,
            totalUsers: 0,
            pendingOrders: 0
        },
        recentOrders: [],
        products: [],
        categories: [],
        users: [],
        loading: false
    },
    
    mutations: {
        SET_STATS(state, stats) {
            state.stats = stats;
        },
        SET_RECENT_ORDERS(state, orders) {
            state.recentOrders = orders;
        },
        SET_PRODUCTS(state, products) {
            state.products = products;
        },
        SET_CATEGORIES(state, categories) {
            state.categories = categories;
        },
        SET_USERS(state, users) {
            state.users = users;
        },
        SET_LOADING(state, loading) {
            state.loading = loading;
        }
    },
    
    actions: {
        async fetchDashboardStats({ commit }) {
            try {
                const response = await axios.get('/api/product/admin/dashboard/stats/');
                commit('SET_STATS', response.data);
                commit('SET_RECENT_ORDERS', response.data.recentOrders || []);
                return response.data;
            } catch (error) {
                console.error('Failed to fetch dashboard stats:', error);
                throw error;
            }
        },
        
        async fetchAdminProducts({ commit }) {
            commit('SET_LOADING', true);
            try {
                const response = await axios.get('/api/product/admin/products/');
                commit('SET_PRODUCTS', response.data);
                return response.data;
            } catch (error) {
                console.error('Failed to fetch products:', error);
                throw error;
            } finally {
                commit('SET_LOADING', false);
            }
        },
        
        async fetchAdminCategories({ commit }) {
            try {
                const response = await axios.get('/api/product/admin/categories/');
                commit('SET_CATEGORIES', response.data);
                return response.data;
            } catch (error) {
                console.error('Failed to fetch categories:', error);
                throw error;
            }
        },
        
        async fetchAdminUsers({ commit }) {
            try {
                const response = await axios.get('/api/product/admin/users/');
                commit('SET_USERS', response.data);
                return response.data;
            } catch (error) {
                console.error('Failed to fetch users:', error);
                throw error;
            }
        },
        
        async createProduct({ dispatch }, productData) {
            try {
                const response = await axios.post('/api/product/admin/products/', productData);
                await dispatch('fetchAdminProducts');
                return response.data;
            } catch (error) {
                console.error('Failed to create product:', error);
                throw error;
            }
        },
        
        async updateProduct({ dispatch }, { id, data }) {
            try {
                const response = await axios.put(`/api/product/admin/products/${id}/`, data);
                await dispatch('fetchAdminProducts');
                return response.data;
            } catch (error) {
                console.error('Failed to update product:', error);
                throw error;
            }
        },
        
        async deleteProduct({ dispatch }, id) {
            try {
                await axios.delete(`/api/product/admin/products/${id}/`);
                await dispatch('fetchAdminProducts');
                return true;
            } catch (error) {
                console.error('Failed to delete product:', error);
                throw error;
            }
        },
        
        async createCategory({ dispatch }, categoryData) {
            try {
                const response = await axios.post('/api/product/admin/categories/', categoryData);
                await dispatch('fetchAdminCategories');
                return response.data;
            } catch (error) {
                console.error('Failed to create category:', error);
                throw error;
            }
        },
        
        async updateCategory({ dispatch }, { id, data }) {
            try {
                const response = await axios.put(`/api/product/admin/categories/${id}/`, data);
                await dispatch('fetchAdminCategories');
                return response.data;
            } catch (error) {
                console.error('Failed to update category:', error);
                throw error;
            }
        },
        
        async deleteCategory({ dispatch }, id) {
            try {
                await axios.delete(`/api/product/admin/categories/${id}/`);
                await dispatch('fetchAdminCategories');
                return true;
            } catch (error) {
                console.error('Failed to delete category:', error);
                throw error;
            }
        }
    },
    
    getters: {
        getStats: state => state.stats,
        getRecentOrders: state => state.recentOrders,
        getProducts: state => state.products,
        getCategories: state => state.categories,
        getUsers: state => state.users,
        isLoading: state => state.loading
    }
};